module.exports = __webpack_public_path__ + "img/logo-ubiflow-260x56.cf3307e0.png";